import { render, staticRenderFns } from "./PerfilDelivery.vue?vue&type=template&id=15cb7fe8"
import script from "../controllers/PerfilDelivery.ts?vue&type=script&lang=ts&external"
export * from "../controllers/PerfilDelivery.ts?vue&type=script&lang=ts&external"
import style0 from "./PerfilDelivery.vue?vue&type=style&index=0&id=15cb7fe8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports